export const actionButtons = [
    // For User List
    { name: "User.Create", actionName: 'PersonalHistory.Users.Create' },
    { name: "User.Edit", actionName: 'PersonalHistory.Users.Edit' },
    { name: "User.Delete", actionName: 'PersonalHistory.Users.Delete' },
    { name: "User.Permission", actionName: 'PersonalHistory.Users.Permission' },

    // For Profile
    { name: "Profile.Personal", actionName: 'PersonalHistory.Profile.Personal' },
    { name: "Profile.FamilyInfo", actionName: 'PersonalHistory.Profile.FamilyInfo' },
    { name: "Profile.Education", actionName: 'PersonalHistory.Profile.Education' },
    { name: "Profile.JobInfo", actionName: 'PersonalHistory.Profile.JobInfo' },

    // For fileTitle List
    { name: "FileTitle", actionName: 'PersonalHistory.FileTitle' },
    { name: "FileTitle.Create", actionName: 'PersonalHistory.FileTitle.Create' },
    { name: "FileTitle.Edit", actionName: 'PersonalHistory.FileTitle.Edit' },
    { name: "FileTitle.Delete", actionName: 'PersonalHistory.FileTitle.Delete' },

    // For PersonComment List
    { name: "PersonComment.Create", actionName: 'PersonalHistory.PersonComment.Create' },
    { name: "PersonComment.Edit", actionName: 'PersonalHistory.PersonComment.Edit' },
    { name: "PersonComment.Delete", actionName: 'PersonalHistory.PersonComment.Delete' },

    // For PersonAttachment List
    { name: "PersonalList.PersonAttachment", actionName: 'PersonalHistory.PersonalList.PersonAttachment' },
    { name: "PersonAttachment.Upload", actionName: 'PersonalHistory.PersonalList.PersonAttachment.Upload' },
    { name: "PersonAttachment.Download", actionName: 'PersonalHistory.PersonalList.PersonAttachment.Download' },
    { name: "PersonAttachment.Delete", actionName: 'PersonalHistory.PersonalList.PersonAttachment.Delete' },

    // For Questionnaire List
    { name: "Files", actionName: 'PersonalHistory.QuestionnaireList.Files' },
    { name: "Print History", actionName: 'PersonalHistory.QuestionnaireList.PrintHistory' },

    // For Company List
    { name: "Company.Create", actionName: 'PersonalHistory.Companies.Create' },
    { name: "Company.Edit", actionName: 'PersonalHistory.Companies.Edit' },
    { name: "Company.Delete", actionName: 'PersonalHistory.Companies.Delete' },
]